module.exports = __webpack_public_path__ + "static/media/america-cup-icon.7f1085f8.svg";